import DateCard, { DateCardTheme, IDateCardProps } from 'components/date-card/DateCard';
import RelatedContent from 'components/related-content/RelatedContent';

import { IRelatedDates } from 'source/NFR.types';

const RelatedDates: React.FC<IRelatedDates> = ({
  dates = [],
  relatedContent,
  usedInSidebar = false,
  isGrid = false
}) => {
  const theme = (): IDateCardProps['theme'] => {
    const themeArray: DateCardTheme[] = ['noPadding', 'noBorder'];
    if (usedInSidebar) return themeArray.concat('sidebar');
    if (isGrid) return themeArray.concat('vertical');
    return themeArray;
  };

  const relatedContentProps = { ...relatedContent, isGrid };

  return (
    <div className="related-dates">
      <RelatedContent {...relatedContentProps} itemMinWidth={280}>
        {dates?.map(date => (
          <DateCard
            headingLevel={3}
            key={date.title}
            theme={theme()}
            {...date}
            usedInSidebar={usedInSidebar}
            isImageLink
            metadataTheme="vertical"
          />
        ))}
      </RelatedContent>
    </div>
  );
};

RelatedDates.displayName = 'RelatedDates';

export default RelatedDates;
